import {
  Autocomplete,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Tooltip,
} from '@mui/material';
import Pagination from 'base/ui/components/Pagination/pagination';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { BsFillPlusSquareFill } from 'react-icons/bs';
import { FaCheck } from 'react-icons/fa';
import { GrEdit } from 'react-icons/gr';
import { HiSearch } from 'react-icons/hi';
import { MdOutlineClose } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { TestTargetDetail } from 'services/testTarget_services';
import * as rootStore from 'stores/root_store';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import { Routing } from './AddTestTarget/addTestTarget';

export function creatTestTarget() {
  return observer(() => {
    const navigate = useNavigate();
    const Style = {
      '.MuiOutlinedInput-root': {
        padding: 0,
        borderRadius: 0,
        fontSize: '13px',
      },
      '.MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
        fontSize: '13px',
      },
      '.MuiAutocomplete-inputRoot .MuiAutocomplete-input[aria-controls]': {
        fontSize: '13px',
      },
    };
    // =================== phân trang ==========================//
    // số lượng items trên 1 trang
    const [pageSize, setPageSize] = useState(PAGE_SIZE_DEFAULT);
    // current page
    const [pageIndex, setPageIndex] = useState(1);
    // set -1 để không bị báo lỗi: (react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (0 > -1).

    // const [pageSelected, setPageSelected] = useState(-1);

    // Form validation-----------------------------------
    const { register, handleSubmit, setValue } = useForm<TestTargetDetail>();

    // ---------------------------STATE VALUE -----------------------------------
    const [testTarget, setTestTarget] = useState<TestTargetDetail>({
      targetName: '',
      targetCode: null,
      stepCode: '',
      actived: null,
      tolerance: '',
      isQualityIndiCation: null,
    });
    // danh sách công đoạn
    const [listRouting, setListRouting] = useState<Routing[]>([]);
    // search keyword
    const [keyWordStepName, setKeyWordStepName] = useState('');

    // value cua Autocomplete
    const [stepCode, setStepCode] = useState('');

    // Set trạng thái để tìm kiếm
    const [status, setStatus] = useState('null');
    const [statusIsTarget, setStatusIsTarget] = useState('null');
    const column = [
      {
        columnName: 'STT',
        align: 'text-center',
        visible: true,
      },
      { columnName: 'Mã chỉ tiêu', align: 'text-center', visible: true },
      { columnName: 'Chỉ tiêu kiểm tra', align: 'text-center', visible: true },
      { columnName: 'Công đoạn', align: 'text-center', visible: true },

      {
        columnName: 'Loại chỉ tiêu',
        align: 'text-center',
        visible: true,
      },
      { columnName: 'Sai số cho phép', align: 'text-center', visible: true },
      {
        columnName: 'Tiêu chuẩn kiểm tra',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Bắt buộc kiểm tra theo lệnh',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Bắt buộc kiểm tra theo thẻ treo',
        align: 'text-center',
        visible: true,
      },

      { columnName: 'Trạng thái', align: 'text-center', visible: true },
      { columnName: 'Chức năng', align: 'text-center', visible: true },
    ];

    const testTargetStore = rootStore.testTargetStore.testTarget;

    // ====================== FUNCTION =============================
    // =========== get keyword stepName ==================
    const handleChangeKeyWordStepName = async (
      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
      setKeyWordStepName(e.target.value);

      await rootStore.routingPresenter.getListRouting(
        rootStore.routingStore,
        e.target.value
      );
      setListRouting(rootStore.routingStore.routing.data);
    };

    const handleChange = (event: SelectChangeEvent) => {
      setStatus(event.target.value);
    };
    const handleChangeStatusTarget = (event: SelectChangeEvent) => {
      setStatusIsTarget(event.target.value);
    };

    const handleChangePageIndex = (data: any) => {
      setPageIndex(data.selected + 1);
    };

    const handleChangePageSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setPageSize(parseInt(e.target.value));
    };

    const handleChangeStepName = (
      e: React.SyntheticEvent<Element, Event>,
      value: Routing | null
    ) => {
      if (value) {
        setStepCode(value.stepCode);
      }
    };

    // các row trong table lấy từ store
    const tableRows = rootStore.testTargetStore.testTarget.data;

    const onSearch = async (data: TestTargetDetail) => {
      setTestTarget({
        actived: JSON.parse(status),
        stepCode: stepCode,
        targetCode: data.targetCode ? Number(data.targetCode) : null,
        targetName: data.targetName,
        tolerance: data.tolerance,
        isQualityIndiCation: JSON.parse(statusIsTarget),
      });
      // console.log(data);
      await rootStore.testTargetPresenter.getListTestTarget(
        rootStore.testTargetStore,
        {
          paging: {
            pageIndex: 1,
            pageSize: pageSize,
          },
          targetCode: data.targetCode ? Number(data.targetCode) : null,
          targetName: data.targetName,
          stepCode: stepCode,
          actived: JSON.parse(status),
          tolerance: data.tolerance,
          isQualityIndiCation: JSON.parse(statusIsTarget),
        }
      );
    };

    // ======================USE EFFECT =====================
    useEffect(() => {
      // lấy danh sách test target theo paging
      const getListTestTarget = async () => {
        await rootStore.testTargetPresenter.getListTestTarget(
          rootStore.testTargetStore,
          {
            paging: {
              pageIndex: pageIndex,
              pageSize: pageSize,
            },
            targetCode: testTarget.targetCode,
            targetName: testTarget.targetName,
            stepCode: testTarget.stepCode,
            actived: testTarget.actived,
            tolerance: testTarget.tolerance,
            isQualityIndiCation: testTarget.isQualityIndiCation,
          }
        );
      };
      getListTestTarget();
    }, [pageIndex]);

    // call list routing
    useEffect(() => {
      // lấy danh sách công đoạn
      const getListRouting = async () => {
        const listRouting = await rootStore.routingPresenter.getListRouting(
          rootStore.routingStore,
          keyWordStepName
        );
        if (listRouting) setListRouting(listRouting);
      };
      getListRouting();
    }, [keyWordStepName]);

    useEffect(() => {
      const getListTestTarget = async () => {
        await rootStore.testTargetPresenter.getListTestTarget(
          rootStore.testTargetStore,
          {
            paging: {
              pageIndex: 1,
              pageSize: pageSize,
            },
            targetCode: testTarget.targetCode,
            targetName: testTarget.targetName,
            stepCode: testTarget.stepCode,
            actived: testTarget.actived,
            tolerance: testTarget.tolerance,
            isQualityIndiCation: testTarget.isQualityIndiCation,
          }
        );
      };
      setPageIndex(1);
      getListTestTarget();
    }, [pageSize]);

    return (
      <div className='w-full py-3 px-5'>
        <div className='flex justify-between items-center mb-2'>
          <h3 className='text-md font-bold text-gray-800 uppercase'>
            Chỉ Tiêu Kiểm Tra
          </h3>
          <button
            type='submit'
            onClick={() => {
              navigate('add');
            }}
            className={`flex items-center text-white bg-blue-700 rounded text-default px-2.5 py-1 text-center focus:outline-none hover:bg-blue-600 `}
          >
            <>
              <BsFillPlusSquareFill className='mr-2' />
              Thêm mới
            </>
          </button>
        </div>
        {/* Form nhập tìm kiếm */}
        <div className='w-full bg-white p-3.5 flex rounded mb-2 border border-neutral-300'>
          <form className='w-full lg:grid lg:grid-cols-2 flex flex-col gap-2'>
            {/* Tìm kiếm theo mã chỉ tiêu targetNumber */}
            {/*  mã chỉ tiêu */}
            <div className='w-full sm:flex-row sm:items-center grid grid-cols-3'>
              <label className='min-w-[150px] font-medium text-default text-gray-700 sm:text-end'>
                Mã chỉ tiêu
              </label>
              <input
                {...register('targetCode')}
                className='col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600'
              />
            </div>
            {/*  tên chỉ tiêu */}
            <div className='w-full sm:flex-row sm:items-center grid grid-cols-3'>
              <label className='min-w-[150px] font-medium text-default text-gray-700 sm:text-end'>
                Tên chỉ tiêu
              </label>
              <input
                {...register('targetName')}
                type='text'
                className='col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600'
              />
            </div>
            {/* công đoạn */}
            <div className='w-full sm:flex-row sm:items-center grid grid-cols-3'>
              <label className='min-w-[150px] font-medium text-default text-gray-700 sm:text-end'>
                Công đoạn
              </label>
              {/* <select
                defaultValue=''
                {...register('stepCode')}
                className='col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600'
              >
                <option className='' value='' disabled>
                  -- Chọn công đoạn --
                </option>
                {listRouting?.map((item) => {
                  return (
                    <option key={item.stepCode} value={item.stepCode}>
                      {item.stepName}
                    </option>
                  );
                })}
              </select> */}

              <Autocomplete
                className='col-span-2 text-gray-700 hover:ring-0 hover:outline-none sm:ml-5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600'
                id='stepName'
                options={listRouting}
                sx={Style}
                classes={{ listbox: 'text-default' }}
                filterOptions={(options, state) => options}
                getOptionLabel={(option) => option.stepName}
                onChange={handleChangeStepName}
                // defaultValue={rootStore.productStore.productSearch.parentCategory}
                renderInput={(params) => (
                  <TextField
                    onChange={handleChangeKeyWordStepName}
                    {...params}
                  />
                )}
              />
            </div>
            {/*  trạng thái */}
            <div className='w-full sm:flex-row sm:items-center grid grid-cols-3'>
              <label className='min-w-[150px] font-medium text-default text-gray-700 sm:text-end'>
                Trạng thái
              </label>
              <FormControl className='flex-1 col-span-2'>
                <Select
                  {...register('actived')}
                  className=' text-gray-700 hover:ring-0 hover:outline-none hover:border-border_input !rounded-none border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600'
                  value={status}
                  onChange={handleChange}
                  displayEmpty
                  sx={{ height: 35 }}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value='null'>
                    <span className='text-default'>Tất cả</span>
                  </MenuItem>
                  <MenuItem
                    className='text-default'
                    onChange={() => {
                      setValue('actived', true);
                    }}
                    value='true'
                  >
                    <span className='text-default'>Đang sử dụng</span>
                  </MenuItem>
                  <MenuItem
                    onChange={() => {
                      setValue('actived', false);
                    }}
                    value='false'
                  >
                    <span className='text-default'>Ngưng sử dụng</span>
                  </MenuItem>
                </Select>
              </FormControl>
            </div>

            {/* sai số cho phép */}
            <div className='w-full sm:flex-row sm:items-center grid grid-cols-3'>
              <label className='min-w-[150px] font-medium text-default text-gray-700 sm:text-end'>
                Sai số cho phép
              </label>
              <input
                {...register('tolerance')}
                type='text'
                className='col-span-2 text-gray-700 border border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600'
              />
            </div>

            {/* chỉ tiêu kiểm tra (loại chỉ tiêu) */}
            <div className='w-full sm:flex-row sm:items-center grid grid-cols-3'>
              <label className='min-w-[150px] font-medium text-default text-gray-700 sm:text-end'>
                Loại chỉ tiêu
              </label>
              <FormControl className='flex-1 col-span-2'>
                <Select
                  {...register('isQualityIndiCation')}
                  className=' text-gray-700 hover:ring-0 hover:outline-none hover:border-border_input !rounded-none border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600'
                  value={statusIsTarget}
                  onChange={handleChangeStatusTarget}
                  displayEmpty
                  sx={{ height: 35 }}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value='null'>
                    <span className='text-default'>Tất cả</span>
                  </MenuItem>
                  <MenuItem
                    className='text-default'
                    onChange={() => {
                      setValue('isQualityIndiCation', true);
                    }}
                    value='true'
                  >
                    <span className='text-default'>Chỉ tiêu định lượng</span>
                  </MenuItem>
                  <MenuItem
                    onChange={() => {
                      setValue('isQualityIndiCation', false);
                    }}
                    value='false'
                  >
                    <span className='text-default'>Chỉ tiêu định tính</span>
                  </MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className='lg:col-span-2 w-full flex justify-center'>
              <button
                onClick={handleSubmit(onSearch)}
                type='submit'
                className={`flex items-center text-white bg-blue-700 rounded text-default px-2.5 py-1 mt-1 text-center focus:outline-none hover:bg-blue-600 `}
              >
                <>
                  <HiSearch className='font-bold text-lg' />
                  Tìm kiếm
                </>
              </button>
            </div>
          </form>
        </div>

        <div className='w-full bg-white p-3.5 rounded border border-neutral-300'>
          {/*=========== Pagination =======================*/}
          <Pagination
            pageCount={testTargetStore.pagesCount}
            forcePage={pageIndex - 1}
            onPageSizeChange={handleChangePageSize}
            onPageChange={handleChangePageIndex}
          />

          {/* =========== Table PO ===============*/}
          <div className={`overflow-x-auto mt-3.5`}>
            <table className='w-full table-auto border-collapse space-collapse text-default'>
              <thead className='font-medium text-gray-700 bg-gray-100'>
                <tr>
                  {column?.map((item, index) => {
                    if (item.visible) {
                      return (
                        <th
                          key={index}
                          scope='col'
                          className={`${
                            item.visible ? '' : 'hidden'
                          } py-1.5 px-5 border whitespace-nowrap text-left ${
                            item.align
                          }`}
                        >
                          {item.columnName}
                        </th>
                      );
                    }
                  })}
                </tr>
              </thead>
              <tbody>
                {tableRows?.map((row, index) => (
                  <tr
                    className={`${1 % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}
                    key={row.testTargetId}
                  >
                    {/* Số thứ tự */}
                    <td className='py-1 border whitespace-nowrap text-center'>
                      {row.stt}
                    </td>
                    {/* mã chỉ tiêu */}
                    <td className='py-1 border whitespace-nowrap text-center'>
                      {row.targetCode}
                    </td>
                    {/* chi tieu kiem tra */}
                    <td className='py-1 px-2 border whitespace-nowrap'>
                      {row.targetName}
                    </td>
                    {/* Cong doan */}
                    <td className='py-1 px-2 border whitespace-nowrap text-left'>
                      {row.stepCode + '/' + row.stepName}
                    </td>
                    {/* chi tieu định lượng */}
                    <td className='py-1 px-2 border whitespace-nowrap'>
                      {row.isQualityIndiCation === null
                        ? ''
                        : row.isQualityIndiCation
                        ? 'Chỉ tiêu định lượng'
                        : 'Chỉ tiêu định tính'}
                    </td>
                    {/* sai số cho phép */}
                    <td className='py-1 px-2 border whitespace-nowrap'>
                      {row.tolerance}
                    </td>
                    {/* tiêu chuẩn kiểm tra */}
                    <Tooltip title={`${row.standard ? row.standard : ''}`}>
                      <td className='py-1 px-2 border max-w-[200px] truncate'>
                        {row.standard}
                      </td>
                    </Tooltip>

                    {/* bắt buộc kiểm tra theo lệnh */}
                    <td className='py-1 px-2 border whitespace-nowrap text-center'>
                      {row.requiredByWO ? (
                        <FaCheck className='text-blue-700 text-lg text-center mx-auto' />
                      ) : (
                        <MdOutlineClose className='text-red-800 font-extrabold text-[24px] mx-auto' />
                      )}
                    </td>
                    {/* bắt buộc kiểm tra theo thẻ treo */}
                    <td className='py-1 px-2 border whitespace-nowrap text-center'>
                      {row.requiredByWOCard ? (
                        <FaCheck className='text-blue-700 text-lg text-center mx-auto' />
                      ) : (
                        <MdOutlineClose className='text-red-800 font-extrabold text-[24px] mx-auto' />
                      )}
                    </td>
                    {/* trang thai */}
                    <td className='py-1 px-2 border whitespace-nowrap text-center'>
                      {row.actived ? (
                        <FaCheck className='text-blue-700 text-lg text-center mx-auto' />
                      ) : (
                        <MdOutlineClose className='text-red-800 font-extrabold text-[24px] mx-auto' />
                      )}
                    </td>
                    {/* mã chỉ tiêu */}
                    <td className='py-1 px-2 border whitespace-nowrap flex justify-center'>
                      <button
                        onClick={() => navigate(`edit/${row.testTargetId}`)}
                        className=' text-default bg-btn_edit py-0.25 px-2.5 rounded-sm border-border_input border flex gap-1 items-center justify-center'
                      >
                        <GrEdit /> Sửa
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <span className='block mt-3.5 text-default'>
            Đang xem {`${testTargetStore.resultsCount}`} trong tổng số{' '}
            {`${testTargetStore.recordsTotal}`} mục
          </span>
        </div>
      </div>
    );
  });
}
